import React, { useState } from 'react';
import { Field, withTypes } from 'react-final-form';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import CustomInputField from '../../../components/form/CustomInputField';
import Icon from '../../../assets/icons/Icon';
import { useDict } from '../../../contexts/LanguageContext';
import { postResetPassword } from '../src/authApis';
import toast from 'react-hot-toast';
import PasswordChecklist from '../../../components/PasswordChecklist';

const ResetPasswordForm = (props) => {
    const { token, email, setIsLoading } = props;

    const dict = useDict();
    const navigate = useNavigate();

    const [showPassword, setShowPassword] = useState(false);
    const [showRePassword, setShowRePassword] = useState(false);
    const [isSuccessfullyReset, setIsSuccessfullyReset] = useState(false);

    const onResetPassword = (values) => {
        setIsLoading(true);
        postResetPassword({ ...values, email, token }, handlePostResetPassword);
        setIsLoading(false);
    };

    const handlePostResetPassword = (response) => {
        setIsSuccessfullyReset(true);
        toast.success(dict.resetPasswordSuccessMessage, {
            duration: 5000,
            id: dict.resetPasswordSuccessMessage,
        });
        navigate('/');
    };

    const { Form } = withTypes();

    const resetPasswordValidate = (values) => {
        const errors = {};

        if (!values.password) {
            errors.password = dict.passwordEmpty;
        } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*,.()\-+_={}[\]{};'\\:"|\\/<>?~`])(?=.{8})/.test(values.password)) {
            errors.password = dict.passwordInvalid;
        }

        if (!values.password_confirmation) {
            errors.password_confirmation = dict.rePasswordEmpty;
        } else if (values.password_confirmation !== values.password) {
            errors.password_confirmation = dict.passwordsNotMatch;
        }

        return errors;
    };

    return (
        <Form onSubmit={(values) => onResetPassword(values)} validate={resetPasswordValidate}>
            {({ handleSubmit, values }) => (
                <form className="form" onSubmit={handleSubmit}>
                    <div className="form__form-group">
                        <div className="text-align-center mt-2 mb-4">
                            <h3 className="font-weight-bold">{dict.resetPassword}</h3>
                        </div>

                        <div className="form__form-group-field">
                            <Field name="password">
                                {({ input, meta }) => (
                                    <CustomInputField
                                        input={input}
                                        meta={meta}
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder={dict.password}
                                        submitted={isSuccessfullyReset}
                                    />
                                )}
                            </Field>
                            <span
                                className={`form__form-group-button${showPassword ? ' active' : ''} form__form-group-button--show-password`}
                                onClick={() => setShowPassword(!showPassword)}
                                role="button"
                                onKeyDown={() => setShowPassword(!showPassword)}
                                tabIndex={0}
                            >
                                <Icon icon={showPassword ? 'Eye' : 'EyeSlash'} />
                            </span>
                        </div>
                    </div>
                    <div className="form__form-group">
                        <div className="form__form-group-field">
                            <Field name="password_confirmation">
                                {({ input, meta }) => (
                                    <CustomInputField
                                        input={input}
                                        meta={meta}
                                        type={showRePassword ? 'text' : 'password'}
                                        placeholder={dict.rePassword}
                                        submitted={isSuccessfullyReset}
                                    />
                                )}
                            </Field>
                            <span
                                className={`form__form-group-button${showRePassword ? ' active' : ''} form__form-group-button--show-password`}
                                onClick={() => setShowRePassword(!showRePassword)}
                                role="button"
                                onKeyDown={() => setShowRePassword(!showRePassword)}
                                tabIndex={0}
                            >
                                <Icon icon={showPassword ? 'Eye' : 'EyeSlash'} />
                            </span>
                        </div>
                    </div>
                    <div className="form__form-group checklist__div">
                        <div className="form__form-group-field">
                            <span className="checklist__span">
                                <PasswordChecklist
                                    password={
                                        values?.password || ''
                                    }
                                    rePassword={
                                        values?.password_confirmation ||
                                        ''
                                    }
                                />
                            </span>
                        </div>
                    </div>
                    <div className="account__btns">
                        <Button
                            color="primary"
                            className="btn account__btn rounded"
                            type="submit"
                        >
                            {dict.resetPassword}
                        </Button>
                    </div>
                </form>
            )}
        </Form>
    );
};

export default ResetPasswordForm;
